import { render, staticRenderFns } from "./SectionPanels.vue?vue&type=template&id=7647f1f6&scoped=true"
import script from "./SectionPanels.vue?vue&type=script&lang=js"
export * from "./SectionPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7647f1f6",
  null
  
)

export default component.exports